import axios from 'axios';

const API_BASE = '/api/transportation-jobs';

export const transportationJobService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },
  uploadFile: async (id, { file, kind }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('kind', kind);
    const response = await axios.post(`${API_BASE}/${id}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  downloadUrl: (id, fileId) => `${API_BASE}/${id}/files/${fileId}/download`,
  openFile: async (id, fileId) => {
    const response = await axios.get(`${API_BASE}/${id}/files/${fileId}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    window.open(url, '_blank', 'noopener,noreferrer');
  },
  deleteFile: async (id, fileId) => {
    const response = await axios.delete(`${API_BASE}/${id}/files/${fileId}`);
    return response.data;
  },
  markPickedUp: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/mark-picked-up`);
    return response.data;
  },
  markDelivered: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/mark-delivered`);
    return response.data;
  },
  submitForApproval: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/submit-for-approval`);
    return response.data;
  },
  approve: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/approve`);
    return response.data;
  },
  cancel: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/cancel`);
    return response.data;
  },
  regeneratePortalToken: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/regenerate-portal-token`);
    return response.data;
  },
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },
};
